import { IPost } from './ipost';


export interface IPostState {
    post: IPost,
    posts: Array<IPost>,
    error?: any
}
